<ng-container *ngIf="change.changeType === changeType.Unchanged">
    {{ change.originalValue | staffingRatio | nullDash }}
</ng-container>
<ng-container *ngIf="change.changeType === changeType.Changed">
    <div class="value-panel">
        <span class="original-value">{{ change?.originalValue | staffingRatio | nullDash }}</span>
        <span class="new-value">{{ change?.newValue | staffingRatio | nullDash }}</span>
    </div>
</ng-container>
